function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, computed, watch, getCurrentInstance } from "vue";
import { definePropType } from "@types-vue/props";
import CommonPushDialog from "./common-push-dialog/index.vue";
import { fetchVersionChannelList } from "@/api/creative/custom";
import { getGmakerProjectChannels } from "@pt/api/gmaker/project.js";
import { getPsProjectChannels } from "@ps/api/project.js";
import { allowedPushChannel } from "./common-push-dialog/shared";
import { defaultResStatus } from "./common-push-dialog/shared";
import _ from "lodash";
import { cloneDeep } from "lodash-es";
import { MaterialMakeFrom } from "@pt/enums/push";
import { checkPushName } from "@pt/api/creative/push";
import { isValidateName } from "@com/utils/number";
import { getCreativeInfoChannels } from "@pt/api/creative";
import { TrafficType } from "@pt/enums/insights";
import { PtBusinessType, PtBusinessConfigs, DefaultNameOptions } from "./common-push-dialog/config";
export default defineComponent({
    name: "PushDialog",
    props: {
        business: {
            type: definePropType(String),
            required: true
        },
        // 是否批量推送
        batch: Boolean,
        versionData: {
            type: definePropType(Object)
        }
    },
    components: {
        CommonPushDialog: CommonPushDialog
    },
    setup: function setup(props, param1) {
        var emit = param1.emit;
        var getChannelList = function getChannelList(customIds, productFrom) {
            if (productFrom === "commonTemplate") {
                return getGmakerProjectChannels({
                    id: customIds[0],
                    basic_id: basicId.value
                }).then(function(res) {
                    return {
                        resStatus: _.get(res, "data.data.res_stats"),
                        channels: _.get(res, "data.data.list").filter(function(item) {
                            return item.enable_push;
                        }).map(function(item) {
                            return item.channel_id;
                        })
                    };
                });
            } else if (productFrom === "ps") {
                return getPsProjectChannels({
                    id: customIds[0],
                    basic_id: basicId.value
                }).then(function(res) {
                    return {
                        resStatus: _.get(res, "data.res_stats"),
                        channels: _.get(res, "data.list").filter(function(item) {
                            return item.enable_push;
                        }).map(function(item) {
                            return item.channel_id;
                        })
                    };
                });
            }
            // 定制图片、视频、定制PL的 default_version source_type都是1
            if (pushDialog.value.from === MaterialMakeFrom.Custom) {
                var _$ref;
                return getCreativeInfoChannels({
                    ids: customIds.toString()
                }).then(function(res) {
                    var _$ref2;
                    return {
                        resStatus: _objectSpread({}, defaultResStatus),
                        channels: (_$ref = (_$ref2 = res.data.data.list) === null || _$ref2 === void 0 ? void 0 : _$ref2.filter(function(item) {
                            return item.enable_push;
                        }).map(function(item) {
                            return item.channel_id;
                        })) !== null && _$ref !== void 0 ? _$ref : []
                    };
                });
            }
            // 定制PL不是Default_version的 source_type都是3
            return fetchVersionChannelList({
                id: customIds[0]
            }).then(function(res) {
                return {
                    resStatus: _.get(res, "data.data.res_stats"),
                    channels: _.get(res, "data.data.list").filter(function(item) {
                        return item.enable_push;
                    }).map(function(item) {
                        return item.channel_id;
                    })
                };
            });
        };
        var handleDialogClose = function handleDialogClose() {
            root.$store.dispatch("creative/pusher/hidePushDialog");
        };
        var validateName = function validateName(value) {
            if (!value) {
                return Promise.resolve();
            }
            var errMsg = root.$t("playTurbo.whole.validateMessage").toString();
            var repeatMsg = root.$t("playTurbo.pushDialog.name.validate.repeat").toString();
            console.log("validateName", value);
            if (!isValidateName(value)) {
                return Promise.reject(errMsg);
            }
            // 定制图片和视频，推送名称用来源id，可能会重复，故用接口验证
            if (props.business === PtBusinessType.CustomVideoImage) {
                return checkPushName({
                    name: value
                }).then(function(res) {
                    if (res.data.code === 0 && res.data.data.is_available) {
                        return Promise.resolve();
                    }
                    return Promise.reject(repeatMsg);
                }).catch(function() {
                    return Promise.reject(repeatMsg);
                });
            }
            return Promise.resolve();
        };
        var handleRepack = function handleRepack(quality) {
            root.$emit("repack", quality);
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var historyName = ref("");
        var ptBusinessConfig = computed(function() {
            return PtBusinessConfigs[props.business];
        });
        var pushDialog = computed(function() {
            return root.$store.state.creative.pusher.pushDialog;
        });
        var pushIds1 = computed(function() {
            var pushIds = root.$store.state.creative.pusher.pushIds;
            return typeof pushIds === "string" ? pushIds.split(",").filter(function(v) {
                return Boolean(v);
            }) : pushIds;
        });
        var basicId = computed(function() {
            return root.$store.state.creative.pusher.basicId;
        });
        var _$ref1;
        var userInfo = computed(function() {
            var _$ref;
            return (_$ref1 = (_$ref = root.$store.state.user) === null || _$ref === void 0 ? void 0 : _$ref.info) !== null && _$ref1 !== void 0 ? _$ref1 : null;
        });
        // 是否需要打包，
        var disablePack = computed(function() {
            // 如果是 定制普通制作的默认版本，不需要打包
            if (props.business === PtBusinessType.CustomNormal && pushDialog.value.from === MaterialMakeFrom.Custom) {
                return true;
            }
            return false;
        });
        var isPlayablePush = computed(function() {
            return [
                PtBusinessType.CustomNormal,
                PtBusinessType.Normal,
                PtBusinessType.Playsmart, 
            ].includes(props.business);
        });
        var enablePackageQuality = computed(function() {
            // 如果是 定制普通制作的默认版本，不需要包体控制
            if (props.business === PtBusinessType.CustomNormal && pushDialog.value.from === MaterialMakeFrom.Custom) {
                return false;
            }
            return Boolean(ptBusinessConfig.value.enablePackageQuality);
        });
        var showDownloadBalance = computed(function() {
            var _$ref5, _$ref3;
            // 无法判断是否可玩的试用套餐，所以根据可玩套餐的下载量是否为零进行判断
            var hasDownloadCount = (_$ref5 = userInfo.value) === null || _$ref5 === void 0 ? void 0 : (_$ref3 = _$ref5.plans) === null || _$ref3 === void 0 ? void 0 : _$ref3.some(function(item) {
                var _$ref, _$ref4;
                return typeof ((_$ref = item.downloads_and_push) === null || _$ref === void 0 ? void 0 : _$ref[1]) === "number" && ((_$ref4 = item.downloads_and_push) === null || _$ref4 === void 0 ? void 0 : _$ref4[1]) > 0;
            });
            if (!hasDownloadCount) {
                return false;
            }
            return ptBusinessConfig.value.showDownloadBalance;
        });
        var nameOptions = computed(function() {
            var options = _toConsumableArray(pushDialog.value.nameOptions);
            return options.map(function(option) {
                var item1 = DefaultNameOptions.find(function(item) {
                    return item.code === option.code;
                });
                if (!item1) {
                    var all = DefaultNameOptions.map(function(item) {
                        return item.code;
                    }).join(",");
                    throw new Error("invalid code ".concat(option.code, ", please check it exists in ").concat(all));
                }
                return _objectSpread({}, item1, option);
            });
        });
        var nameameSuffixOptions = computed(function() {
            var _$ref, _$ref6;
            // 如果视频项目并且不是批量任务，不需要后缀
            if (pushDialog.value.from === MaterialMakeFrom.Veditor && !pushDialog.value.isBatchTask) {
                return [];
            }
            var _$ref7;
            return (_$ref7 = (_$ref = PtBusinessConfigs.value) === null || _$ref === void 0 ? void 0 : (_$ref6 = _$ref.nameSuffixCodes) === null || _$ref6 === void 0 ? void 0 : _$ref6.map(function(code) {
                var option = DefaultNameOptions.find(function(item) {
                    return item.code === code;
                });
                if (!option) {
                    var all = DefaultNameOptions.map(function(item) {
                        return item.code;
                    }).join(",");
                    throw new Error("invalid code ".concat(code, ", please check it exists in ").concat(all));
                }
                return cloneDeep(option);
            })) !== null && _$ref7 !== void 0 ? _$ref7 : [];
        });
        var resStatus = ref(_objectSpread({}, defaultResStatus));
        var allowedChannels = ref([]);
        // apps需要根据产品信息进行筛选过滤
        var apps = computed(function() {
            var _value, _$ref;
            var id = Array.isArray(pushIds1.value) ? pushIds1.value[0] : pushIds1.value;
            return (_$ref = (_value = ptBusinessConfig.value).getApps) === null || _$ref === void 0 ? void 0 : _$ref.call(_value, id, {
                isDefaultVersion: pushDialog.value.isDefaultVersion,
                templateId: pushDialog.value.templateId
            });
        });
        var onPushSuccess = function() {
            root.$store.dispatch("GetUserInfo");
            emit("push-success");
        };
        var listeners = computed(function() {
            return _objectSpreadProps(_objectSpread({}, root.$listeners), {
                "push-success": onPushSuccess
            });
        });
        watch([
            // 若开启，切换tab时候，会受它影响，发出请求
            // () => props.enablePackageQuality,
            function() {
                return pushIds1.value;
            },
            function() {
                return ptBusinessConfig.value.productFrom;
            }, 
        ], function() {
            console.log("pushIds.value", pushIds1.value);
            var ids = Array.isArray(pushIds1.value) ? pushIds1.value : [
                pushIds1.value
            ];
            if (props.business === PtBusinessType.Video) {
                resStatus.value = _objectSpread({}, defaultResStatus);
                allowedChannels.value = allowedPushChannel;
            } else if (ids.length > 0) {
                getChannelList(ids, ptBusinessConfig.value.productFrom).then(function(param) {
                    var channels = param.channels, stats = param.resStatus;
                    console.log("stats", stats, channels);
                    resStatus.value = _objectSpread({}, defaultResStatus, stats);
                    allowedChannels.value = channels;
                });
            } else {
                resStatus.value = _objectSpread({}, defaultResStatus);
                allowedChannels.value = [];
            }
        }, {
            immediate: true,
            deep: true
        });
        function handleBeforePush(data) {
            return _handleBeforePush.apply(this, arguments);
        }
        function _handleBeforePush() {
            _handleBeforePush = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data) {
                var isTask;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            data = cloneDeep(data);
                            data.from = pushDialog.value.from;
                            isTask = pushDialog.value.isTask;
                            if (isTask) {
                                // 不管是什么业务，都给它同样的值，让后端自己取
                                data.task_id = Number(pushIds1.value);
                                data.object_ids = undefined;
                            } else {
                                data.object_ids = (Array.isArray(pushIds1.value) ? pushIds1.value : [
                                    pushIds1.value
                                ]).map(function(v) {
                                    return Number(v);
                                });
                                data.task_id = undefined;
                            }
                            return _ctx.abrupt("return", data);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _handleBeforePush.apply(this, arguments);
        }
        return {
            historyName: historyName,
            apps: apps,
            userInfo: userInfo,
            showDownloadBalance: showDownloadBalance,
            TrafficType: TrafficType,
            PtBusinessType: PtBusinessType,
            allowedChannels: allowedChannels,
            disablePack: disablePack,
            enablePackageQuality: enablePackageQuality,
            ptBusinessConfig: ptBusinessConfig,
            nameOptions: nameOptions,
            nameameSuffixOptions: nameameSuffixOptions,
            resStatus: resStatus,
            pushIds: pushIds1,
            pushDialog: pushDialog,
            listeners: listeners,
            isPlayablePush: isPlayablePush,
            handleDialogClose: handleDialogClose,
            handleRepack: handleRepack,
            handleBeforePush: handleBeforePush,
            validateName: validateName
        };
    }
});
